/* eslint-disable no-console */

import { register } from "register-service-worker";
import { setInviteCode } from "@/utils/inviteCode";

if (process.env.NODE_ENV === "production") {
  register(`/sw.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered() {
      // 安装页面，缓存邀请码
      if (window.location.pathname === "/install") {
        console.log("Service worker has been registered.");
        console.time("缓存分享码成功");
        setInviteCode().then(() => {
          console.timeEnd("缓存分享码成功");
        });
      }
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated() {
      console.log("New content is available; please refresh.");
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}
